import { FC } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "./constants";
import { Layout } from "../components/Layout";
import { MainPage } from "../features/main/page";
import ScrollToHashElement from "../components/ScrollToHashElement";

const DEFAULT_PATH = ROUTES.main.createURL();

export const Router: FC = () => (
  <BrowserRouter>
    <ScrollToHashElement />
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index path={ROUTES.main.path} element={<MainPage />} />
        <Route path="*" element={<Navigate to={DEFAULT_PATH} />} />
      </Route>
    </Routes>
  </BrowserRouter>
);
